import React, { useEffect, useState, useRef, useContext } from "react";
import PageSeo from "../../components/seo/PageSeo";
import countriesCode from "i18n-iso-countries";
import english from "i18n-iso-countries/langs/en.json";
import Error from "../../components/Error/Error";
import Flag from "../../components/Flag";
import { toast } from "../../components/toast/toast";
import { copyText } from "../../utils/clipboard";
import { activeOrdersCall, cancelCall, finishCall, buyCall, getServicesCatalog, getServicesPaginated, getServiceByName } from "../../calls";
import { handleError, shouldShowToUser } from "../../utils/errorHandler";
import { countryName as localCountryName, countryNameFromSlug } from "../../utils/i18nFormat";
import { orderActionError } from "../../utils/serverMessages";
import block10 from "../../images/block.png";
import check from "../../images/check.png";
import close from "../../images/close.png";
import expired from "../../images/expired.png";
import framImage from "../../images/Frame.svg";
import detail1 from "../../images/Detail1.svg";
import tick from "../../images/tickVector.svg";
import A1 from "../../images/A1.svg";
import A2 from "../../images/A2.svg";
import A3 from "../../images/A3.svg";
import A4 from "../../images/A4.svg";
import A5 from "../../images/A5.svg";
import A6 from "../../images/A6.svg";
import CountryList2 from "country-list-with-dial-code-and-flag";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import "./home.css";
import "./home-signal.css";
import Instructions from "../instructions/Instructions";
import Support from "../support/Support";
import Overview from "../overview/Overview";

import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { deepParam } from "../../utils/deepLink";
import { useTranslation } from "react-i18next";

import { Helmet } from "react-helmet";

const axios = require("axios");
// "" (chaine vide) = meme origine en prod -> ?? et non || (|| ecraserait la chaine vide)
const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://127.0.0.1:8000";

var countryl = require("country-list-with-dial-code-and-flag");

countriesCode.registerLocale(english);

const HomePage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [searchParams] = useSearchParams();

  const {
    setShowModal,
    setShowModal2,
    setIsLoggedIn,
    showModal,
    showModal2,
    isLoggedIn,
    setBalance,
    showErrorModal,
    setShowErrorModal,
    errorMsg,
    setErrorMsg,
  } = props;

  const data = [];
  const orderData = {
    balance: 18,
    orders: [],
  };

  // États pour la nouvelle structure
  const [service, setService] = useState(""); // Service sélectionné
  const [country, setCountry] = useState(""); // Pays sélectionné
  const [servicesData, setServicesData] = useState({}); // Structure: {service: {country: {providers: {}}}}
  const [countriesForService, setCountriesForService] = useState([]); // Pays disponibles pour le service sélectionné
  const [buyData, setBuyData] = useState({ country: "", service: "", provider: "" });
  const [showMore, setShowMore] = useState(true);
  const [showMoreService, setShowMoreService] = useState(true);
  const [countryCode, setcountryCode] = useState(0);
  const [countryActive, setCountryActive] = useState(0);
  const [serviceActive, setServiceActive] = useState(0);
  const [orderListData, setOrderListData] = useState(orderData);
  const pollBusyRef = useRef(false); // une seule relecture en vol
  const listSeqRef = useRef(0); // seule la dernière requête partie s'applique
  const setBalanceRef = useRef(setBalance);
  setBalanceRef.current = setBalance; // updateBalance (App.js) change d'identité à chaque rendu
  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("");
  const [needResponsive, setResponsive] = useState(false);
  const [size, setSize] = useState(0);
  const [countryname, setCountryname] = useState("");
  const [value, setValue] = React.useState("1");
  const { t, i18n } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const [isBuying, setIsBuying] = useState(false);
  const [openCountry, setOpenCountry] = useState(null); // État pour l'accordion des pays
  const [servicesMeta, setServicesMeta] = useState({}); // {service: {countries_available, total_providers}}
  const [countriesLoading, setCountriesLoading] = useState(false); // chargement lazy des pays
  const [sortBy, setSortBy] = useState("quality"); // tri du STEP 2 (design Signal)
  const [sortOpen, setSortOpen] = useState(false); // dropdown "Sort by"
  const [showAllCountries, setShowAllCountries] = useState(false); // Top 10 vs liste complète

  // Deep-link depuis les pages SEO (front-next) : #service=whatsapp&country=canada
  // (fragment ; l'ancienne forme ?service=... reste acceptee, voir utils/deepLink.js)
  // Slugs normalisés (tirets) des deux côtés ; consommé une seule fois au chargement.
  const normSlug = (x) => (x || "").toLowerCase().replace(/[_\s]+/g, "-");
  const deepLinkRef = useRef({
    service: normSlug(deepParam(searchParams, "service")),
    country: normSlug(deepParam(searchParams, "country")),
  });

  // Seuils de fiabilité des fournisseurs (r = taux de réussite mesuré).
  const REL_HIGH = 0.18, REL_MID = 0.06, REL_MIN_N = 20;
  const relLevel = (v) => (!v ? "none" : v.r >= REL_HIGH ? "high" : v.r >= REL_MID ? "mid" : "low");
  const relEstimate = (v) => !!v && (!v.local || v.n < REL_MIN_N);

  const SORT_OPTIONS = [
    { key: "quality", label: t("signal.sort-quality") },
    { key: "popularity", label: t("signal.sort-popularity") },
    { key: "cheapest", label: t("signal.sort-cheapest") },
    { key: "expensive", label: t("signal.sort-expensive") },
    { key: "stock", label: t("signal.sort-stock") },
  ];
  // quality = fiabilité mesurée par le moteur arbitraj (quality_score serveur) ;
  // stock et popularity restent des proxys (nb de fournisseurs).
  const sortCountries = (a, b) => {
    const pa = a.minPrice ?? getMinPrice(a.providers) ?? Infinity;
    const pb = b.minPrice ?? getMinPrice(b.providers) ?? Infinity;
    const hasRel = (x) => Object.keys(x.reliability || {}).length > 0;
    const qa = hasRel(a) ? (a.quality ?? -1) : -1;
    const qb = hasRel(b) ? (b.quality ?? -1) : -1;
    const ca = Object.keys(a.providers || {}).length;
    const cb = Object.keys(b.providers || {}).length;
    switch (sortBy) {
      case "cheapest": return pa - pb;
      case "expensive": return pb - pa;
      case "popularity": {
        const POP = ["usa", "uk", "unitedkingdom", "france", "germany", "canada", "netherlands", "spain", "italy", "poland", "indonesia", "india", "philippines", "russia"];
        const ia = POP.indexOf(a.key); const ib = POP.indexOf(b.key);
        return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib) || qb - qa || cb - ca;
      }
      case "stock": return cb - ca || pa - pb;
      case "quality":
      default: return qb - qa || cb - ca || pa - pb;
    }
  };

  // Helpers
  const getMinPrice = (providers) =>
    providers ? Math.min(...Object.values(providers)) : null;

  const getProvidersSorted = (providers, reliability) => {
    const rel = reliability || {};
    return Object.entries(providers || {}).sort(([na, pa], [nb, pb]) => {
      if (sortBy === "quality") {
        const ra = rel[na] ? rel[na].r : -1;
        const rb = rel[nb] ? rel[nb].r : -1;
        return rb - ra || pa - pb;
      }
      if (sortBy === "expensive") return pb - pa;
      return pa - pb;
    });
  };

  // Libelles affiches dans la langue du site (le serveur renvoie des slugs et
  // des noms de pays anglais, et des identifiants de fournisseur internes).
  const displayCountry = (c) => localCountryName(c.isoCode, c.name || c.key, i18n.language);
  const countryLabel = (countryKey) => {
    const c = countriesForService.find((x) => x.key === countryKey);
    return c ? displayCountry(c) : countryNameFromSlug(countryKey, i18n.language);
  };
  const serviceLabel = (name) =>
    String(name || "").toLowerCase() === "other" ? t("signal.service-other") : name;
  const providerLabel = (name) => {
    const m = /^provider[_\s-]?(\w+)$/i.exec(String(name || ""));
    return m ? t("signal.provider-n", { n: m[1] }) : name;
  };

  // Feedback d'achat (toasts design "Notifications")
  const notifyBuySuccess = (data) => {
    toast(
      "ok",
      t("signal.t-number-ready"),
      data?.number
        ? t("signal.t-number-ready-body", { number: data.number })
        : t("signal.t-number-ready-generic"),
    );
  };

  const notifyBuyError = (e, countryKey) => {
    const status = e?.response?.status;
    // Le texte du serveur ("Insufficient funds", "TRY AGAIN", messages techniques
    // ou francais) n'est plus affiche : seulement journalise, le client lit
    // un texte traduit choisi d'apres le statut HTTP.
    if (e?.response?.data?.message) console.error("[buy]", status, e.response.data.message);
    if (status === 401) {
      setIsLoggedIn(false);
      localStorage.removeItem("token");
      setShowModal(true);
      return;
    }
    if (status === 406) {
      toast("err", t("signal.t-no-balance"), t("signal.t-no-balance-body"), {
        action: { label: t("signal.t-add-funds"), onClick: () => navigate(`/deposit`) },
      });
      return;
    }
    const body = status && status >= 400 && status < 500
      ? t("signal.t-no-number-body")
      : t("signal.t-try-again");
    toast("err", t("signal.t-no-number"), body);
  };

  // Achat sans provider
  const buyCountry = async (countryKey) => {
    if (!isLoggedIn) {
      setShowModal(true); // pas connecté → modale de connexion
      return;
    }
    setIsBuying(true);
    setBuyData({ service, country: countryKey, provider: undefined });
    const country_code = (countriesForService.find((c) => c.key === countryKey) || {}).code;
    toast("info", t("signal.t-searching"), `${serviceLabel(service)} · ${countryLabel(countryKey)}`, { ttl: 2500 });
    try {
      const res = await buyCall({ service, country: countryKey, country_code });
      if (res?.status === 200) {
        listActiveOrders();
        setBalance(res.data.balance);
        notifyBuySuccess(res.data);
      }
    } catch (e) {
      notifyBuyError(e, countryKey);
    } finally {
      setIsBuying(false);
    }
  };

  // Achat avec provider
  const buyWithProvider = async (countryKey, providerName) => {
    if (!isLoggedIn) {
      setShowModal(true); // pas connecté → modale de connexion
      return;
    }
    setIsBuying(true);
    setBuyData({ service, country: countryKey, provider: providerName });
    const country_code = (countriesForService.find((c) => c.key === countryKey) || {}).code;
    toast("info", t("signal.t-searching"), `${serviceLabel(service)} · ${countryLabel(countryKey)} · ${providerLabel(providerName)}`, { ttl: 2500 });
    try {
      const res = await buyCall({ service, country: countryKey, provider: providerName, country_code });
      if (res?.status === 200) {
        listActiveOrders();
        setBalance(res.data.balance);
        notifyBuySuccess(res.data);
      }
    } catch (e) {
      notifyBuyError(e, countryKey);
    } finally {
      setIsBuying(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCopy = (text) => {
    copyText(text).then((ok) => {
      if (!ok) return;
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    });
  };

  useEffect(() => {
    const updateSize = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    setSize(window.innerWidth);
    if (size <= 1100 && size >= 450) {
      setResponsive(true);
    } else {
      setResponsive(false);
    }
  }, [size]);

  // Détail d'un service (pays + providers + prix), chargé à la demande + mis en cache
  const loadServiceDetail = async (serviceName, baseData) => {
    const base = baseData || servicesData;
    // déjà en cache ?
    if (base[serviceName] && Object.keys(base[serviceName]).length > 0) {
      updateCountriesForService(serviceName, base);
      return;
    }
    setCountriesLoading(true);
    setCountriesForService([]);
    try {
      const res = await getServiceByName(serviceName);
      const detail = (res.data && res.data[serviceName]) || {};
      const merged = { ...base, [serviceName]: detail };
      setServicesData(merged);
      updateCountriesForService(serviceName, merged);
    } catch (err) {
      handleError(err, setShowErrorModal, setErrorMsg);
    } finally {
      setCountriesLoading(false);
    }
  };

  // Charger la LISTE des services (endpoint paginé léger, ~3.7Ko/page) puis lazy-load le détail
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Un seul appel : le catalogue entier (~64 Ko gzip). Les 88 appels
        // paginés coûtaient ~3,2 s à eux seuls (6 connexions max par hôte).
        let meta = null;
        try {
          const all = await getServicesCatalog();
          if (all?.data?.success && all.data.data) meta = { ...all.data.data };
        } catch (e) {
          meta = null;
        }
        if (!meta) {
          // Repli : backend sans /order/services_catalog.
          const first = await getServicesPaginated(1);
          const totalPages = first.data?.pagination?.total_pages || 1;
          meta = { ...(first.data?.data || {}) };
          if (totalPages > 1) {
            const rest = await Promise.all(
              Array.from({ length: totalPages - 1 }, (_, i) =>
                getServicesPaginated(i + 2).catch(() => null)
              )
            );
            rest.forEach((r) => {
              if (r?.data?.data) meta = { ...meta, ...r.data.data };
            });
          }
        }
        if (cancelled) return;
        // Ordre d'affichage : populaires épinglés d'abord (l'ordre du cache backend
        // change à chaque rebuild), puis le reste par couverture pays décroissante.
        const POPULAR = [
          "whatsapp", "telegram", "google", "instagram", "facebook", "tiktok",
          "twitter", "openai", "discord", "snapchat", "tinder", "amazon",
          "apple", "microsoft", "netflix", "uber", "viber", "wechat", "steam", "paypal",
        ];
        const rank = new Map(POPULAR.map((s, i) => [s, i]));
        const names = Object.keys(meta).sort((a, b) => {
          const ra = rank.has(a) ? rank.get(a) : Infinity;
          const rb = rank.has(b) ? rank.get(b) : Infinity;
          if (ra !== rb) return ra - rb;
          return (
            (meta[b]?.countries_available || 0) - (meta[a]?.countries_available || 0) ||
            a.localeCompare(b)
          );
        });
        // placeholders vides : la liste s'affiche, le détail se charge à la sélection
        const placeholders = {};
        names.forEach((n) => (placeholders[n] = {}));
        setServicesMeta(meta);
        setServicesData(placeholders);
        const deepSvc = deepLinkRef.current.service
          ? names.find((n) => normSlug(n) === deepLinkRef.current.service)
          : null;
        const firstService = deepSvc || names[0];
        if (firstService) {
          if (deepSvc) {
            setQuery2(deepSvc); // filtre la liste sur le service deep-linké
            // input non contrôlé : refléter le filtre pour que l'utilisateur puisse l'effacer
            if (inputServiceRef.current) inputServiceRef.current.value = deepSvc;
          }
          setService(firstService);
          setServiceActive(0);
          loadServiceDetail(firstService, placeholders);
        }
      } catch (err) {
        console.error("API Error:", err);
        handleError(err, setShowErrorModal, setErrorMsg);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []); // Pas de dépendances pour éviter les re-renders

  const inputRef = useRef(null);
  const inputServiceRef = useRef(null);
  const inputHandler = () => {
    if (inputRef.current) {
      inputRef.current.value = country;
    }
  };

  // Charger les commandes actives si connecté
  useEffect(() => {
    if (isLoggedIn) {
      const seq = ++listSeqRef.current;
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
        url: `${BASE_URL}/order/list_active`,
      })
        .then((response) => {
          if (seq === listSeqRef.current) {
            setOrderListData(response.data);
            setBalance(response.data.balance);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            setIsLoggedIn(false);
            localStorage.removeItem("token");
            return;
          }
          handleError(err, setShowErrorModal, setErrorMsg);
        });
    }
  }, [isLoggedIn, setIsLoggedIn, setErrorMsg, setShowErrorModal, setBalance]);

  // Nouvelle fonction pour mettre à jour les pays disponibles pour un service
  const updateCountriesForService = (serviceName, data = null) => {
    const servicesSource = data || servicesData;
    if (servicesSource && servicesSource[serviceName]) {
      const countries = Object.keys(servicesSource[serviceName]).map(countryKey => {
        const countryData = servicesSource[serviceName][countryKey];
        return {
          key: countryKey,
          name: countryData.country_name || countryKey,
          code: countryData.country_code || countryKey.slice(0, 2).toUpperCase(),
          isoCode: countryData.country_code || "",
          providers: countryData.providers || {},
          // champs serveur (GetServiceByNameView) — fallback client si absents
          quality: countryData.quality_score,
          minPrice: countryData.min_price,
          reliability: countryData.reliability || {},
        };
      });
      
      // Trier par prix le plus bas
      countries.sort((a, b) => {
        const priceA = Math.min(...Object.values(a.providers));
        const priceB = Math.min(...Object.values(b.providers));
        return priceA - priceB;
      });
      
      setCountriesForService(countries);
      
      // Sélectionner le pays deep-linké s'il existe, sinon le moins cher
      if (countries.length > 0) {
        let idx = 0;
        const wanted = deepLinkRef.current.country;
        if (wanted) {
          const found = countries.findIndex(
            (c) => normSlug(c.key) === wanted || normSlug(c.name) === wanted
          );
          if (found >= 0) {
            idx = found;
            // rendre le pays visible et évident : accordion ouvert + recherche filtrée dessus
            setOpenCountry(countries[found].key);
            const shown = localCountryName(countries[found].isoCode, countries[found].name, i18n.language);
            setQuery(shown);
            if (inputRef.current) inputRef.current.value = shown;
          }
          deepLinkRef.current.country = ""; // one-shot
        }
        setCountry(countries[idx].key);
        setCountryActive(idx);
        updateBuyData(serviceName, countries[idx]);
      }
    } else {
      setCountriesForService([]);
    }
  };

  // Fonction pour mettre à jour les données d'achat
  const updateBuyData = (serviceName, countryData) => {
    const providers = countryData.providers || {};
    const providerNames = Object.keys(providers);
    if (providerNames.length > 0) {
      // Sélectionner le provider le moins cher
      const cheapestProvider = providerNames.reduce((a, b) => 
        providers[a] < providers[b] ? a : b
      );
      
      setBuyData({
        service: serviceName,
        country: countryData.key,
        provider: cheapestProvider
      });
    }
  };

  const updateServiceStyle = (amount, country, service, provider, index) => {
    setServiceActive(index);
    setBuyData({
      amount: amount,
      country: country,
      service: service,
      provider: provider,
    });
  };

  const listActiveOrders = () => {
    const seq = ++listSeqRef.current;
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${localStorage.getItem("token")}`,
      },
      url: `${BASE_URL}/order/list_active`,
    })
      .then((response) => {
        if (seq === listSeqRef.current) {
          setOrderListData(response.data);
          setBalance(response.data.balance);
        }
      })
      .catch((err) => {
        handleError(err, setShowErrorModal, setErrorMsg);
      });
  };

  const executeCall = (id, callback) => {
    const isCancel = callback === cancelCall;
    callback(id).then((response) => {
      if (response.status === 200) {
        listActiveOrders();
        if (isCancel) {
          toast("info", t("signal.t-cancelled"), t("signal.t-cancelled-body", { id }));
        } else {
          toast("ok", t("signal.t-finished"), t("signal.t-finished-body", { id }));
        }
      }
    }).catch((err) => {
      toast("err", isCancel ? t("signal.t-cancel-failed") : t("signal.t-finish-failed"), orderActionError(err, t));
    });
  };

  const ACTIVE_STATUSES = ["sms pending", "success", "finished"];
  const ORDER_TTL_MS = 20 * 60 * 1000; // une activation expire après 20 min

  // tick 1s pour le compte à rebours des commandes en attente
  const [nowTick, setNowTick] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNowTick(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  // Rafraîchissement : tant qu'une commande attend son SMS, on relit list_active
  // (lecture en base côté API ; gestion y pousse le SMS).
  const POLL_PENDING_MS = 5000; // SMS attendu
  const POLL_RECEIVED_MS = 15000; // SMS reçu, carte encore affichée : SMS suivants
  const pollOrders = orderListData.orders || [];
  const hasPending = pollOrders.some((o) => o.status === "sms pending");
  const hasRecent = pollOrders.some((o) => {
    if (o.status !== "success") return false;
    const c = new Date(o.created_at).getTime();
    return isFinite(c) && c + ORDER_TTL_MS > nowTick;
  });
  const pollMs = !isLoggedIn ? 0 : hasPending ? POLL_PENDING_MS : hasRecent ? POLL_RECEIVED_MS : 0;
  useEffect(() => {
    if (!pollMs) return undefined;
    let alive = true;
    const tick = () => {
      if (document.hidden || pollBusyRef.current) return;
      pollBusyRef.current = true;
      const seq = ++listSeqRef.current;
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
        url: `${BASE_URL}/order/list_active`,
      })
        .then((r) => {
          if (alive && seq === listSeqRef.current) {
            setOrderListData(r.data);
            setBalanceRef.current(r.data.balance);
          }
        })
        .catch((err) => {
          if (alive && err.response && err.response.status === 401) {
            setIsLoggedIn(false);
            localStorage.removeItem("token");
          }
          // autres erreurs : silencieuses (prochain passage)
        })
        .finally(() => {
          pollBusyRef.current = false;
        });
    };
    const id = setInterval(tick, pollMs);
    const onVisible = () => {
      if (!document.hidden) tick();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [pollMs, setIsLoggedIn]);

  const remainingLabel = (item) => {
    const end = new Date(item.created_at).getTime() + ORDER_TTL_MS;
    if (!isFinite(end)) return "";
    const ms = end - nowTick;
    if (ms <= 0) return t("signal.expiring");
    const m = Math.floor(ms / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return t("signal.time-left", { time: `${m}:${String(s).padStart(2, "0")}` });
  };

  // Code reçu : l'API renvoie un tableau sms_codes, on prend le dernier
  const smsCodeOf = (item) => {
    const codes = item.sms_codes || [];
    return codes.length ? codes[codes.length - 1] : item.sms_code || "";
  };

  // Extrait le code seul du texte du SMS (« G-123456 ... » → « 123456 »)
  const extraireCode = (texte) => {
    if (!texte) return "";
    // deux blocs séparés par - ou espace (WhatsApp « 123-456 »)
    const deuxBlocs = texte.match(/\b\d{3}[- ]\d{3}\b/);
    if (deuxBlocs) return deuxBlocs[0];
    // sinon le premier nombre de 4 à 8 chiffres
    const nombre = texte.match(/\b\d{4,8}\b/);
    return nombre ? nombre[0] : "";
  };

  // Cartes de commandes actives (design "Signal" 5b)
  const activeOrderCards = orderListData.orders
    .filter((item) => {
      if (!ACTIVE_STATUSES.includes(item.status)) return false;
      // en attente : l'API l'expire et la rembourse, on la garde
      if (item.status === "sms pending") return true;
      // reçue : on masque la carte après le TTL (elle reste dans l'historique)
      const created = new Date(item.created_at).getTime();
      if (!isFinite(created)) return true; // date absente/invalide : ne rien masquer
      return created + ORDER_TTL_MS > nowTick;
    })
    .map((item, index) => {
      const received = item.status === "success" || item.status === "finished";
      const sms = smsCodeOf(item); // texte complet reçu
      const code = extraireCode(sms); // code seul, si on sait l'extraire
      return (
        <div key={item.id || index} className={`ao-card ${received ? "ao-card--ok" : ""}`}>
          <div className="ao-card__top">
            <span className="ao-card__label">
              <Flag code={item.country_code} /> {serviceLabel(item.service)}
            </span>
            <span className={`sg-status ${received ? "sg-status--ok" : "sg-status--warn"}`}>
              {received ? t("signal.received") : t("signal.pending")}
            </span>
          </div>
          <div className="ao-box">
            <span className="ao-box__num">{item.number}</span>
            <button className="sg-copy" onClick={() => handleCopy(item.number)}>
              {isCopied ? `✓ ${t("signal.copied")}` : t("signal.copy")}
            </button>
          </div>
          {sms ? (
            <>
              <div className="ao-box ao-box--code">
                <span className="ao-box__code">{code || sms}</span>
                <button
                  className="sg-copy"
                  style={{ color: "var(--color-success)" }}
                  onClick={() => handleCopy(code || sms)}
                >
                  {isCopied ? `✓ ${t("signal.copied")}` : t("signal.copy-code")}
                </button>
              </div>
              {/* SMS entier sous le code quand on n'a affiché que le code seul */}
              {code && code !== sms && <p className="ao-card__sms">{sms}</p>}
            </>
          ) : (
            <div className="ao-card__foot">
              <span className="ao-card__wait">
                {t("signal.waiting-sms")}{item.created_at ? <> · <b className="ao-card__timer">{remainingLabel(item)}</b></> : "…"}
              </span>
              {item.status === "sms pending" && (
                <span className="ao-card__actions">
                  <button className="ao-act" onClick={() => executeCall(item.id, cancelCall)}>
                    {t("signal.cancel")}
                  </button>
                  <button className="ao-act ao-act--ok" onClick={() => executeCall(item.id, finishCall)}>
                    {t("signal.finish")}
                  </button>
                </span>
              )}
            </div>
          )}
        </div>
      );
    });

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  useEffect(() => {
    setValue("1");
  }, []);

  function tabClick(tab) {
    navigate(`/${tab}`);
  }

  // Seulement les logos presents dans /img (front-next/public/img) : un nom sans
  // fichier faisait une requete 404 a chaque affichage (prom, momo... 20/10/2026).
  const allowedKeys = ['not in the list', '163com', '23red', '4', '4fun', '5', '6', '888casino', 'adidas', 'air1', 'air2', 'airbnb', 'aliexpress', 'alipay', 'alpha', 'amasia', 'amazon', 'aol', 'apple', 'aptekaru', 'article2', 'article3', 'article4', 'article5', 'article6', 'article7', 'astropay', 'avito', 'avon', 'baidu', 'benefits', 'bereal', 'bet,65', 'betfair', 'biedronka', 'bigolive', 'bilibili', 'bip', 'bitclout', 'blabla', 'blablacar', 'blizzard', 'blizzardbattlenet', 'bolt', 'bumble', 'burgerking', 'car1', 'careem', 'careem2', 'championcasino', 'citymobil', 'citymobilfull', 'cliqq', 'cloudchat', 'coinbase', 'communitygaming', 'coursehero', 'craiglist', 'cryptocom', 'deliveroo', 'delivery', 'dent', 'depop', 'didi', 'DiDiRider', 'disc', 'disc1', 'discord', 'dodopizza', 'dominos pizza', 'doordash', 'dostavista', 'douyu', 'easypay', 'ebay', 'eneba', 'error_page-min', 'escapefromtarkov', 'expressmoney', 'faberlic', 'facebook', 'faceit', 'foodhub', 'foodpanda', 'foody', 'fora', 'galaxychat', 'gamekit', 'getir', 'gett', 'giftcloud', 'glovo', 'google', 'googlevoice', 'grabtaxi', 'grindr', 'groupme', 'happn', 'hermes', 'hezzl', 'hily', 'hinge', 'hotline', 'hqtrivia', 'huya', 'icecasino', 'icq', 'imo', 'indrive', 'indriver', 'insta', 'instag', 'instag1', 'instagram', 'iqiyi', 'iqos', 'ivi', 'izi', 'jdcom', 'joyride', 'justdating', 'kaggle', 'kakaotalk', 'karusel', 'kazanexpress', 'keybase', 'kfc', 'kwai', 'lamoda', 'lenta', 'lightchat', 'likee', 'line msg', 'linkedin', 'linode', 'livescore', 'lukoil azs', 'lyft', 'lyka', 'magnit', 'mail.ru', 'mamba', 'mcdonalds', 'mega', 'megogo', 'meta', 'metro', 'michat', 'microsft', 'microsoft', 'monese', 'moneylion', 'mosru', 'mosruuuu', 'mrgreen', 'mrq', 'myfishka', 'myglo', 'naver', 'netflix', 'nike', 'nimotv', 'nttgame', 'offerup', 'ok.ru', 'okcupid', 'olacabs', 'olx', 'openai', 'oriflame', 'other', 'ozon', 'paddypower', 'pay1', 'pay2', 'paypa', 'paypal', 'paysafecard', 'pca', 'perfluence', 'pgbonus', 'pof', 'poshmark', 'potato chat', 'protonmail', 'redbook', 'revolut', 'rozetka', 'russiaflag', 'sellmonitor', 'shopee', 'signal', 'skout', 'skype', 'snap1', 'snap2', 'snapcha', 'snapchat', 'sneakersnstuff', 'steam', 'stormgain', 'switips', 'talkang', 'tango', 'tantan', 'taobao', 'telegram', 'telegram1', 'telegram2', 'tencentqq', 'tenchat', 'ticketmaster', 'tiktok', 'tinder', 'tradeup', 'trip', 'trucaller1', 'truecaller', 'truecaller2', 'twilio', 'twitch', 'twitter', 'u163', 'uber', 'uber1', 'uber2', 'uberr', 'uklon', 'ukrnet', 'venmo', 'viber', 'vinted', 'virtnum', 'wechat', 'weibo', 'weverse', 'whatsapp 1', 'whatsapp', 'wildberries', 'wise', 'wish', 'wolt', 'wp', 'xiaomi', 'yahoo', 'yalla', 'yandex', 'yappy', 'yemeksepeti', 'yikyak', 'yola', 'youla', 'zalo', 'zcity', 'zilch', 'zoho', 'zupee'];

  function renderServiceCard(serviceName, index, key = index) {
    const isAllowed = allowedKeys.includes(serviceName);
    const isSelected = service === serviceName;
    
    return (
      <div 
        key={key} 
        className={`service-content ${isSelected ? 'activeCountry' : ''}`}
        onClick={() => {
          setService(serviceName);
          setServiceActive(index);
          setOpenCountry(null);
          loadServiceDetail(serviceName);
        }}
        style={{ cursor: 'pointer' }}
      >
        <div className="service-icon">
          {isAllowed ? (
            <img
              src={`/img/${serviceName}.png`}
              alt={serviceName}
              width="25px"
              height="25px"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <div className="service-placeholder" style={{
              width: '25px',
              height: '25px',
              backgroundColor: '#f0f0f0',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              color: '#666'
            }}>
              {serviceName.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        <span className="service-name">{serviceLabel(serviceName)}</span>
        {servicesMeta[serviceName] &&
          servicesMeta[serviceName].countries_available != null && (
            <span className="service-meta">
              {t("signal.countries-count", { count: servicesMeta[serviceName].countries_available })}
            </span>
          )}
      </div>
    );
  }

  // Nouvelle logique pour afficher les services disponibles
  const servicesList = servicesData && Object.keys(servicesData).length > 0 ? 
    Object.keys(servicesData)
    .filter((serviceName) => {
      // Filtrer par recherche
      return query2.toLowerCase() === ""
        ? true
        : serviceName.toLowerCase().includes(query2.toLowerCase());
    })
    .map((serviceName, index) => renderServiceCard(serviceName, index)) : [];

  // Aucun service ne correspond a la recherche : carte "other" de secours.
  const showNotFound = !!servicesData && Object.keys(servicesData).length > 0 && query2.trim() !== "" && servicesList.length === 0 && Object.prototype.hasOwnProperty.call(servicesData, "other");

  // Composant CountryCard avec nouvelle structure
  function CountryCard({
    countryKey,
    countryName,
    countryCode,
    providers,
    reliability,
    isOpen,
    onToggle,
    onBuyCountry,
    onBuyWithProvider,
    isBusy,
  }) {
    const providersSorted = getProvidersSorted(providers, reliability);
    const minPrice = getMinPrice(providers);
    const hasRel = providersSorted.some(([name]) => (reliability || {})[name]);
    const hasEst = providersSorted.some(([name]) => relEstimate((reliability || {})[name]));
    const hasNone = providersSorted.some(([name]) => !(reliability || {})[name]);

    return (
      <div className={`cr ${isOpen ? 'open' : ''}`}>
        <div
          className="cr-row"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls={`providers-${countryKey}`}
        >
          <span className="cr-flag">
            <Flag code={countryCode} />
          </span>
          <span className="cr-name">{countryName}</span>
          <span className="cr-meta">
            {t("signal.providers-count", { count: providersSorted.length })}
          </span>
          <span className="cr-price">
            {minPrice != null ? `${t("signal.from")} $${minPrice.toFixed(4)}` : '—'}
          </span>
          <button
            className={`cr-buy ${isOpen ? 'cr-buy--solid' : ''}`}
            onClick={(e) => { e.stopPropagation(); onBuyCountry(); }}
            disabled={isBusy}
          >
            {isBusy ? <span className="cr-spinner" /> : t("overview.buy")}
          </button>
        </div>

        {isOpen && (
          <div id={`providers-${countryKey}`} className="cr-subs" role="region">
            {providersSorted.length === 0 && (
              <div className="cr-sub cr-sub--empty">{t("signal.no-providers")}</div>
            )}
            {providersSorted.map(([providerName, price]) => {
              const v = (reliability || {})[providerName];
              const lvl = relLevel(v);
              const est = relEstimate(v);
              const label = t(`signal.rel-${lvl}`) + (est ? ` (${t("signal.rel-est")})` : "");
              return (
                <div key={providerName} className="cr-sub">
                  <span className={`cr-dot cr-dot--${lvl}${est ? " cr-dot--est" : ""}`} role="img" title={label} aria-label={label} />
                  <span className="cr-sub__name">{providerLabel(providerName)}</span>
                  <span className="cr-price">${price.toFixed(4)}</span>
                  <button
                    className="cr-buy cr-buy--sm"
                    onClick={() => onBuyWithProvider(providerName)}
                    disabled={isBusy}
                  >
                    {isBusy ? <span className="cr-spinner" /> : t("overview.buy")}
                  </button>
                </div>
              );
            })}
            {hasRel && (
              <div className="cr-legend">
                <span>{t("signal.rel-legend")}</span>
                <span className="cr-legend__item"><span className="cr-dot cr-dot--high" aria-hidden="true" />{t("signal.rel-high-short")}</span>
                <span className="cr-legend__item"><span className="cr-dot cr-dot--mid" aria-hidden="true" />{t("signal.rel-mid-short")}</span>
                <span className="cr-legend__item"><span className="cr-dot cr-dot--low" aria-hidden="true" />{t("signal.rel-low-short")}</span>
                {hasEst && (
                  <span className="cr-legend__item"><span className="cr-dot cr-dot--high cr-dot--est" aria-hidden="true" />{t("signal.rel-est")}</span>
                )}
                {hasNone && (
                  <span className="cr-legend__item"><span className="cr-dot cr-dot--none" aria-hidden="true" />{t("signal.rel-none-short")}</span>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // Pays filtrés + triés (design Signal : Sort by + Top 10)
  const filteredCountries = countriesForService
    .filter((item) => {
      if (query.toLowerCase() === "") return true;
      const q = query.toLowerCase();
      // Nom localise, nom anglais du serveur ou slug : la recherche marche dans
      // la langue du site comme avec les noms anglais (liens profonds).
      return (
        displayCountry(item).toLowerCase().includes(q) ||
        (item.name || "").toLowerCase().includes(q) ||
        (item.key || "").toLowerCase().includes(q)
      );
    })
    .sort(sortCountries);

  const isSearching = query.trim() !== "";
  const visibleCountries =
    showAllCountries || isSearching ? filteredCountries : filteredCountries.slice(0, 10);

  const countriesListAccordion = visibleCountries.map((countryData) => {
    const isOpen = openCountry === countryData.key;
    return (
      <CountryCard
        key={countryData.key}
        countryKey={countryData.key}
        countryName={displayCountry(countryData)}
        countryCode={countryData.code}
        providers={countryData.providers}
        reliability={countryData.reliability}
        isOpen={isOpen}
        onToggle={() => setOpenCountry(isOpen ? null : countryData.key)}
        onBuyCountry={() => buyCountry(countryData.key)}
        onBuyWithProvider={(providerName) => buyWithProvider(countryData.key, providerName)}
        isBusy={isBuying && buyData?.country === countryData.key}
      />
    );
  });

  return (
    <>
      <PageSeo path="" />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("signal.seo-home-title")}</title>
        <meta
          name="description"
          content={t("signal.seo-home-desc")}
        />
        <meta
          name="keywords"
          content="SMS Verification service,Virtual phone number,SMS receive service,2FASMS"
        />
        <meta name="author" content="2FASMS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="index, follow" data-react-helmet="true" />
      </Helmet>

      <div className="container-lg">
        <div className="show row flex-md-row margin-top-10 same-space-bottom">
          {/* Colonne des services et pays élargie */}
          <div className="col-12 col-sm-12 col-md-7 pe-lg-3 mt-3 mt-md-0 col-lg-6 mobile-screen">
            
            {/* Section services avec scope isolé */}
            <div className="countryListNew px-4 Homepage">
              <div className="ds-step__head">
                <span className="ds-step__badge">{t("signal.step-badge", { n: 1 })}</span>
                <span className="ds-step__title">{t("signal.step1")}</span>
                <span className="ds-step__meta">
                  {t("signal.available", { count: Object.keys(servicesData).length || 0 })}
                </span>
              </div>
              <form className="ds-search-wrap">
                <input
                  ref={inputServiceRef}
                  className="me-2 search-country-input ds-search"
                  type="search"
                  placeholder={`${t("overview.search-service")}`}
                  aria-label={t("overview.search-service")}
                  onChange={(e) => setQuery2(e.target.value)}
                />
              </form>
              <div className="margin-top-10 data-row mx-0 w-100 countrylist-height countrylistsidebar">
                <div className="All-country-list">
                  {showNotFound ? (
                    <>
                      <div className="svc-notfound" role="status">{t("signal.service-not-found", { other: t("signal.service-other") })}</div>
                      {renderServiceCard("other", Object.keys(servicesData).indexOf("other"), "other-fallback")}
                    </>
                  ) : (
                    servicesList
                  )}
                </div>
              </div>
            </div>

            {/* Section pays avec scope isolé */}
            {service && (
              <div className="countryListNew px-4 mt-4">
                <div className="ds-step__head">
                  <span className="ds-step__badge">{t("signal.step-badge", { n: 2 })}</span>
                  <span className="ds-step__title">{t("signal.step2")}</span>
                  {!isSearching && (
                    <span className="ds-toppill-group">
                      <button
                        type="button"
                        className={`ds-toppill ${!showAllCountries ? "is-on" : ""}`}
                        onClick={() => setShowAllCountries(false)}
                      >
                        {t("signal.top10")}
                      </button>
                      <button
                        type="button"
                        className={`ds-toppill ${showAllCountries ? "is-on" : ""}`}
                        onClick={() => setShowAllCountries(true)}
                      >
                        {t("signal.all-count", { count: filteredCountries.length || 0 })}
                      </button>
                    </span>
                  )}
                  <span className="ds-step__meta">{t("signal.for-service", { service: serviceLabel(service) })}</span>
                </div>
                <form className="ds-search-wrap">
                  <input
                    ref={inputRef}
                    className="me-2 search-country-input ds-search"
                    type="search"
                    placeholder={t("signal.search-country")}
                    aria-label={t("signal.search-country")}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </form>
                <div className="ds-sortrow">
                  <span className="ds-sortrow__label">{t("signal.sort-by")}</span>
                  <span className="ds-sortrow__line"></span>
                  <span className="ds-sort">
                    <button
                      type="button"
                      className="ds-sort__btn"
                      onClick={() => setSortOpen(!sortOpen)}
                    >
                      {SORT_OPTIONS.find((o) => o.key === sortBy)?.label}{" "}
                      <span className="ds-sort__chev">▾</span>
                    </button>
                    {sortOpen && (
                      <div className="ds-sort__menu">
                        {SORT_OPTIONS.map((o) => (
                          <button
                            key={o.key}
                            type="button"
                            className={`ds-sort__opt ${sortBy === o.key ? "is-on" : ""}`}
                            onClick={() => { setSortBy(o.key); setSortOpen(false); }}
                          >
                            <span className="ds-sort__radio"></span>
                            {o.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </span>
                </div>
                <div className="margin-top-10 data-row mx-0 w-100 countrylist-height">
                  <div className="All-country-list">
                    {countriesLoading ? (
                      <div className="text-center text-muted py-4">
                        <p>{t("signal.loading-countries")}</p>
                      </div>
                    ) : countriesListAccordion.length > 0 ? countriesListAccordion : (
                      <div className="text-center text-muted py-4">
                        <p>{t("signal.no-countries")}</p>
                      </div>
                    )}
                  </div>
                </div>
                {!countriesLoading && filteredCountries.length > 10 && !isSearching && (
                  <div className="ds-showmore">
                    <span className="ds-showmore__info">
                      {t("signal.showing", { shown: visibleCountries.length, total: filteredCountries.length })}
                    </span>
                    <button
                      type="button"
                      className="ds-showmore__btn"
                      onClick={() => setShowAllCountries(!showAllCountries)}
                    >
                      {showAllCountries ? t("signal.show-top") : t("signal.show-all")}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Colonne principale ajustée */}
          <div className="col-12 col-sm-12 col-md-5 col-lg-6 text-align-start">
            {/* Commandes actives — cartes (design Signal) */}
            {isLoggedIn && (
              <div className="ao-panel">
                <div className="ao-head">
                  <span className="ao-head__dot"></span>
                  <span className="ao-head__title">{`${t("overview.active-orders")}`}</span>
                </div>
                <div className="ao-list">
                  {activeOrderCards.length > 0 ? (
                    activeOrderCards
                  ) : (
                    <div className="sg-empty">
                      <b style={{ display: "block", color: "var(--color-ink)", marginBottom: 4 }}>
                        {t("signal.no-active-title")}
                      </b>
                      {t("signal.no-active-body")}
                    </div>
                  )}
                </div>
              </div>
            )}
            
            {/* Tabs */}
            <div className="tabs-content main">
              <TabContext value={value}>
                <Box className="tabs-design">
                  <TabList
                    className="tabnavbar"
                    onChange={handleChange}
                    aria-label={t("overview.overview-main-title")}
                  >
                    <Tab
                      className={
                        value === "1"
                          ? "lab active8 active-tab"
                          : " unactive-tab "
                      }
                      label={`${t("overview.overview-main-title")}`}
                      value="1"
                      onClick={(e) => {
                        tabClick("overview");
                      }}
                    />
                    <Tab
                      className={
                        value == "2"
                          ? "lab active8 active-tab"
                          : " unactive-tab "
                      }
                      label={`${t("overview.instructions-rules")}`}
                      value="2"
                      onClick={(e) => {
                        tabClick("instructions");
                      }}
                    />

                    <Tab
                      className={
                        value == "3"
                          ? "lab active8 active-tab"
                          : " unactive-tab "
                      }
                      label={`${t("overview.support-tab")}`}
                      value="3"
                      onClick={(e) => {
                        tabClick("support");
                      }}
                    />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <Overview
                    setShowModal={setShowModal}
                    setShowModal2={setShowModal2}
                    setIsLoggedIn={setIsLoggedIn}
                    showModal={showModal}
                    showModal2={showModal2}
                    isLoggedIn={isLoggedIn}
                    showErrorModal={showErrorModal}
                    setShowErrorModal={setShowErrorModal}
                    errorMsg={errorMsg}
                    setErrorMsg={setErrorMsg}
                  />
                </TabPanel>
                <TabPanel value="2">
                  <Instructions />
                </TabPanel>
                <TabPanel value="3">
                  <Support />
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </div>
        <Error
          showErrorModal={showErrorModal}
          setShowErrorModal={setShowErrorModal}
          errorMsg={errorMsg}
        />
      </div>
    </>
  );
};

export default HomePage;
